module.exports = __webpack_public_path__ + "img/platform2.12e3c494.png";